/* eslint-disable import/prefer-default-export */
import { createTheme } from '@material-ui/core/styles';
// import background from '../assets/img/background/gse.png';
import logo from '../assets/img/marketPlace/logoLetmiEcu.svg';
import MuliFont from '../assets/font/muli_font/Muli-Light.ttf';

const muli = {
  fontFamily: 'Muli-Light',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 400,
  src: `
    local('Muli-Light'),
    local('Muli-Light'),
    url(${MuliFont}) format('ttf')
  `,
  unicodeRange:
    'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
};

export default createTheme({
  app: {
    favicon: 'LetmiEcuu.ico',
    title: 'Letmi',
  },
  palette: {
    primary: {
      main: '#0059AD',
      contrastText: '#fff',
      light: '#E6EFF7',
      hover: '#00407D',
    },
    secondary: {
      main: '#ff6a98',
    },
    third: {
      main: '#585858',
    },
    error: {
      main: '#d61103',
    },
  },
  header: {
    logo,
    backgroundColor: '#1E1A34',
    colorText: '#FFFFFF',
    badgeItems: {
      backgroundColor: '#07D8B4',
      color: '#212121',
      border: '#07D8B4',
    },
    appBar: {
      backgroundColor: '#163357 !important',
    },
    countrySelector: {
      hover: 'rgba(0,0,0,0.05)',
      icon: '#FFFFFF',
    },
    currencyText: {
      color: '#333',
    },
    menu: {
      typography: '#0059AD',
      items: {
        typography: '#3B3B3B',
      },
      selectedItem: {
        backgroundColor: 'transparent',
        hoverBackgroundColor: '#E5E5E5',
      },
    },
  },
  body: {
    backgroundColor: '#F5F4FE',
    form: {
      titleColor: '#212121',
      inputBackgroundColor: '#FFFFFF',
      border: '#E0E0E0',
      backgroud: '#FFFFFF',
      bkgColorErr: '#FEE2E2',
      iconErrColor: '#94001B',
      colorErrText: '#94001B',
      infoOutlinedIcon: '#4B5563',
      location: {
        backgroundColor: '#F5F5F5',
        color: '#212121',
        arrow: {
          color: '#F5F5F5',
        },
      },
    },
    stepper: {
      active: '#212121',
      uncompleted: '#A6A6A6',
      completed: '#737373',
      connectorActive: '#9CA3AF',
      connectorCompleted: '#9CA3AF',
      connectorDisabled: '#E5E7EB',
      iconRoot: '#E5E5E5',
      iconActive: '#0059AD',
      iconCompleted: '#0059AD',
      iconText: '#A6A6A6',
      iconActiveText: '#ffffff',
    },
    cart: {
      products: {
        main: '#FFFFFF',
        secondary: '#e0e0e0',
        third: '#EBF2F4',
        text: '#3B3B3B',
        hover: 'rgba(0,0,0,0.06)',
        bodyCard: '#F5F5F5',
      },
      assigment: {
        bgColor: '#B2F3E8',
      },
    },
    form2: {
      textColor: '#737373',
      border: '#A6A6A6',
      field: '#ACC0CD',
      backgcolor: '#FFFFFF',
    },
    dialog: {
      accept: '#BD0023',
      colorIcon: '#D16500',
    },
    loading: {
      backdrop: '#fff',
    },
    errorCard: {
      backgroundColor: '#FFFFFF',
      boxShadow: 'rgba(0,0,0,0.05)',
      icon: '#BD0023',
      title: '#20252C',
      description: '#212121',
      retryButtonBackgroundColor: '#0059AD',
      retryButtonColor: '#FFFFFF',
      hover: '#004587',
    },
    successCard: {
      backgroundColor: '#FFFFFF',
      boxShadow: 'rgba(0,0,0,0.05)',
      icon: '#EF4444',
      title: '#212121',
      description: '#212121',
    },
    warningCard: {
      backgroundColor: '#FFFFFF',
      boxShadow: 'rgba(0,0,0,0.05)',
      title: '#20252C',
      retryButton: {
        backgroundColor: '#0059AD',
        color: '#FFFFFF',
        hover: {
          backgroundColor: '#004587',
          boxShadow: 'rgba(112, 87, 236, 0.3)',
        },
      },
    },
    warningLicenseAssignment: {
      backgroundColor: '#FFFFFF',
      boxShadow: 'rgba(0,0,0,0.05)',
      title: '#2C323A',
      description: '#2C323A',
    },
    radio: {
      color: '#737373',
    },
    switchBase: {
      color: '#737373',
      disabled: {
        color: '#737373',
        track: {
          backgroundColor: '#E5E5E5',
        },
      },
    },
    promotionalCodes: {
      success: {
        backgroundColor: '#CBF1D8',
        colorIcon: '#4FBE75',
        colorText: '#4FBE75',
      },
    },
    maximumProductAlert: {
      backgroundColor: '#EDE9FE',
      border: '#EDE9FE',
      textColor: '#1B52E0',
    },
  },
  overrides: {
    MuiButton: {
      root: {
        textTransform: 'none',
      },
      label: {
        fontWeight: 'bold',
      },
    },
    MuiCssBaseline: {
      '@global': {
        body: {
          backgroundColor: '#F5F4FE',
          WebkitBackgroundSize: 'cover',
          MozBackgroundSize: 'cover',
          OBackgroundSize: 'cover',
          backgroundSize: 'cover',
        },
        '@font-face': [muli],
      },
    },
  },
});
